// GENERAL CONTROLS

import AsideLeft from './components/asideLeft';
import Benchmark from './components/benchmark';
import Box from './components/box';
import Calendar from './components/calendar';
import ConfirmButton from './components/confirmButton';
import Copy from './components/copy';
import DebugPanel from './components/debugPanel';
import { appVersion } from './components/debugPanel';
import DeleteWarning from './components/deleteWarning';
import Details from './components/details';
import FloatingMenu from './components/floatingMenu';
import Footer from './components/footer';
import Help from './components/help';
import Info from './components/info';
import Loading from './components/loading';
import Modal from './components/modal';
import Paging from './components/paging';
import Picker from './components/picker';
import ProgressBar from './components/progressBar';
import SaveButton from './components/saveButton';
import Scroller from './components/scroller';
import SlideDown from './components/slideDown';
import Success from './components/success';
import Table from './components/table';
import Tabs from './components/tabs';
import TitleBar from './components/titleBar';

export {
	AsideLeft,
	Benchmark,
	Box,
	Calendar,
	ConfirmButton,
	Copy,
	DebugPanel,
	DeleteWarning,
	Details,
	FloatingMenu,
	Footer,
	Help,
	Info,
	Loading,
	Modal,
	Paging,
	Picker,
	ProgressBar,
	SaveButton,
	Scroller,
	SlideDown,
	Success,
	Table,
	Tabs,
	TitleBar,
};

// FORM CONTROLS

import Audio from './components/forms/audio';
import Buttons from './components/forms/buttons';
import Date from './components/forms/date';
import Date2 from './components/forms/date2';
import File from './components/forms/file';
import Image from './components/forms/image';
import Label from './components/forms/label';
import Person from './components/forms/person';
import Select from './components/forms/select';
import Tags from './components/forms/tags';
import Text from './components/forms/text';
import Textarea from './components/forms/textarea';
import Toggle from './components/forms/toggle';
import Selectv2 from './components/forms/selectv2';
import Video from './components/forms/video';

export const Forms = {
	Audio,
	Buttons,
	Date,
	Date2,
	File,
	Image,
	Label,
	Person,
	Select,
	Selectv2,
	Tags,
	Text,
	Textarea,
	Toggle,
	Video,
};

// HELPERS

import { existsAndHasLength, getPage, sort, sum } from './helpers/array';
import { arrangeTiles, shrinkFont, truncateText, matchWidth, getEventButton } from './helpers/dom';
import { sortData } from './helpers/treeview';
import { configureStore } from './helpers/reduxHelpers';
import { hasReceivedNewProps, setModalOpen } from './helpers/reactHelpers';
import {
	vowels,
	vowelsAndY,
	aOrAn,
	fileSizes,
	bytesToSize,
	displayMinutes,
	displaySeconds,
	possession,
	pluralise,
	colourByIndex,
	regExs,
	matchRegEx,
	formatTextToHtml,
	ensureProtcol,
	containsExt,
	arrayToString,
	capitalise,
	arraysEqual,
	formatMetric,
	isLaterVersion,
	getOrdinalSuffix,
	systemText,
} from './helpers/string';

import { DebugInfo } from './helpers/debughelpers';
export { DebugInfo, appVersion };

export const ArrayHelpers = { existsAndHasLength, getPage, sort, sum };
export const ControlHelpers = { sortData };
export const DomHelpers = { arrangeTiles, shrinkFont, truncateText, matchWidth, getEventButton };
export const ReduxHelpers = { configureStore };
export const ReactHelpers = { hasReceivedNewProps, setModalOpen };
export const StringHelpers = {
	vowels,
	vowelsAndY,
	aOrAn,
	fileSizes,
	bytesToSize,
	displayMinutes,
	displaySeconds,
	possession,
	pluralise,
	colourByIndex,
	regExs,
	matchRegEx,
	formatTextToHtml,
	ensureProtcol,
	containsExt,
	arrayToString,
	capitalise,
	arraysEqual,
	formatMetric,
	isLaterVersion,
	getOrdinalSuffix,
};
export const SystemText = systemText;

// VIEWS

import ComingSoon from './views/comingSoon';
import Error from './views/error';
import Forbidden from './views/forbidden';
import NotFound from './views/notFound';

export { ComingSoon, Error, Forbidden, NotFound };
